import React, { Component } from 'react';
import { Modal, Row, Col } from "react-bootstrap";

class ModalForm extends Component {
    state = {
        show: this.props.isopen,
    }

    componentWillReceiveProps (props) {
        this.setState({
            show: props.isopen
        });
    }

    cerrarModal = () => (e) => {
        this.props.cerrar();
        this.setState({ show: false });
    }

    render() {
        let { contenido, titulo } = this.props;
        return (
            <Modal bsSize ="large" backdrop ="static" show = {this.state.show} className="modal-event-top" onHide = {this.cerrarModal()}>
                <Modal.Header 
                    closeButton = {true}>
                    <Modal.Title>
                        <span style={{fontSize: 12, color:"#1f2f6e"}}><i className="fa fa-addrest-card"></i> {titulo}</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {contenido}
                </Modal.Body>
            </Modal>
        );
    }
}
 
export default ModalForm;


// WEBPACK FOOTER //
// ./src/components/Modal/ModalForm.jsx